var _defs, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-vesta",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 305.001,
    height: 90.101,
    viewBox: "0 0 305.001 90.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8b133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#f8af2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#f6a724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#f49b11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e84e1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    stopColor: "#e41b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e20613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1141",
    "data-name": "Grupo 1141",
    transform: "translate(23.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1562",
    "data-name": "Caminho 1562",
    d: "M104.6,88.49S92.93,86.441,92.93,78.556s5.992-12.142,1.894-15.3c0,0,4.257-.945,4.888,6.781,0,0,5.205-7.254-2.049-16.084s-4.415-14.349-1.1-18.137,6.781-6.623,5.519-11.828c0,0,3.311,3,2.522,5.992s-8.516,10.565-1.894,14.194c0,0,7.244,2.072,4.257-5.364,0,0,6.309,2.208,8.044,6.781s3.47,11.986-8.2,23.656S104.6,88.49,104.6,88.49Z",
    transform: "translate(-92.93 -23.99)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1563",
    "data-name": "Caminho 1563",
    d: "M119.694,168.356a.011.011,0,0,0,0-.006s-12.2,11.456-.832,17.774C118.859,186.121,110.2,179.184,119.694,168.356Z",
    transform: "translate(-107.19 -121.621)",
    fill: "#12100b",
    opacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1564",
    "data-name": "Caminho 1564",
    d: "M25.685,122.79,45.2,158.057,42,163.893,19.25,122.79Zm57.974,0L55.4,173.853l-3.907,7.053-.3-.55-.039.081-2.917-5.27,5.584-10.09,23.4-42.285h6.435Z",
    transform: "translate(-19.25 -90.809)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1565",
    "data-name": "Caminho 1565",
    d: "M247.533,116.565V111.47h54.122v5.095Zm5.095,51.594h49.024v5.095H247.53V125.8h5.095v11.611h42.608v5.095h-42.6Z",
    transform: "translate(-173.637 -83.153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1566",
    "data-name": "Caminho 1566",
    d: "M438.4,128.122a11.642,11.642,0,0,0,11.63,11.63H470.7a16.725,16.725,0,1,1,0,33.451H433.3v-5.092H470.7a11.63,11.63,0,0,0,0-23.261H450.029a16.725,16.725,0,1,1,0-33.451H487.94V116.5H450.029A11.635,11.635,0,0,0,438.4,128.122Z",
    transform: "translate(-299.273 -83.106)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1567",
    "data-name": "Caminho 1567",
    d: "M620.62,116.595V111.5h54.637v5.095Zm24.258,56.679V125.833h5.095v47.441Z",
    transform: "translate(-425.959 -83.173)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1568",
    "data-name": "Caminho 1568",
    d: "M786.668,130.872l3.02,5.859-19.428,37.355H764.19Zm41.388,43.214h-6.069l-23.355-44.9-5.538-10.65,3.033-5.833,3.8,7.309Z",
    transform: "translate(-523.055 -83.985)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVesta);
export default __webpack_public_path__ + "static/media/logo-vesta.3b8b59b118e332046919ddbbecc42269.svg";
export { ForwardRef as ReactComponent };